export const Role = {
    path: '/configurations/roles',
    name: 'roles',
    component: () => import('@/views/Setting/Role/RolePage.vue'),
    children: [
        {
            path: '/configurations/roles/add',
            name: 'roles.add',
            component: () => import('@/views/Setting/Role/Form/RoleForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/configurations/roles/edit/:id',
            name: 'roles.edit',
            component: () => import('@/views/Setting/Role/Form/RoleForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/configurations/roles/delete/:id',
            name: 'roles.delete',
            component: () => import('@/views/Setting/Role/Form/RoleForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/configurations/roles/privileges/edit/:roleId',
            // path: '/privileges/:roleId',
            name: 'roles.privileges.edit',
            component: () => import('@/views/Setting/Privilege/PrivilegePage.vue'),
            props: {updateAction: true},
        },
        {
            path: '/configurations/roles/privileges/view/:roleId',
            // path: '/privileges/:roleId',
            name: 'roles.privileges.view',
            component: () => import('@/views/Setting/Privilege/PrivilegePage.vue'),
            props: {viewAction: true},
        },
    ]
}